import React, { useState } from "react";

const TransactionPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [counter, setCounter] = useState(1);

  const handleSend = () => {
    setIsLoading(true);
    setErrorMessage("");
    setCounter(1);

    // Simulate counting and then an error
    const interval = setInterval(() => {
      setCounter((prev) => {
        if (prev < 58) {
          return prev + 1;
        } else {
          clearInterval(interval);
          setIsLoading(false); // Stop loader when error occurs
          setErrorMessage("Transfer Failed: Wallet needs to be verified. (Make some historys in your  wallet)");
          return prev;
        }
      });
    }, 50);
  };

  return (
    <>
    <div className="bg-black h-screen">
       <div className="pt-[12%]">
       <div className="max-w-md mx-auto bg-gray-900 text-white p-6 rounded-lg shadow-lg ">
      <h1 className="text-2xl font-bold mb-6 text-center">Complete Transfer</h1>

      <div className="mb-4">
        <p className="text-gray-400">Recipient:</p>
        <p className="text-lg font-semibold">Dzung Nguyen</p>
      </div>

      <div className="mb-4">
        <p className="text-gray-400">Amount in USD:</p>
        <p className="text-lg font-semibold">$10,800,000</p>
      </div>

      <div className="mb-6">
        <p className="text-gray-400">Amount in BTC:</p>
        <p className="text-lg font-semibold">$105.98 BTC.</p>
      </div>

      <div className="mb-6">
        <p className="text-gray-400">Wallet Address:</p>
        <p className="text-lg font-semibold">bc1q54hjevpfeuyf2rqwx......</p>
      </div>

      <div className="mb-6">
        <p className="text-gray-400">Transfer Fee:</p>
        <p className="text-lg font-semibold">0.00285BTC</p>
      </div>
      <div className="mb-6">
        <p className="text-gray-400">Time:</p>
        <p className="text-lg font-semibold">18:20 28-01-2025</p>
      </div>


      {!isLoading && errorMessage === "" && (
        <button
          onClick={handleSend}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Send
        </button>
      )}

      {isLoading && (
        <div className="text-center my-6">
          <div className="loader border-t-4 border-blue-500 w-12 h-12 rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-lg font-semibold">Processing...</p>
          <p className="text-red-500 text-lg font-semibold mt-4">{counter}%</p>
        </div>
      )}

      {errorMessage && (
        <div className="text-center my-6">
          <p className="text-red-500 text-lg font-semibold mt-4">{counter}%</p>
          <p className="mt-4 text-red-400 text-sm">{errorMessage}</p>
        </div>
      )}
    </div>
       </div>
    </div>


<div className="max-w-sm mx-auto bg-gray-900 text-white p-6 rounded-lg shadow-lg  my-[15%]">
<div className="text-center mb-6">
  <div className="flex justify-center items-center mb-4">
    <div>
      <img src="eth-removebg-preview.png" alt="" className='w-[50px]'/>
    </div>
    <h2 className="text-xl font-bold">ETH (eth)</h2>
  </div>
  <h1 className="text-[1.5rem] font-extrabold text-red-500">- 1055.56ETH</h1>
  <p className="text-yellow-500 flex justify-center items-center mt-2">
    <span className="mr-2">Refunded</span>
    {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 16h-1v-4h-1m1 0h.01m-6.938 4h10.123a1 1 0 00.894-1.447L12.894 5.553a1 1 0 00-1.788 0L5.447 14.553A1 1 0 006.342 16z"
      />
    </svg> */}
  </p>
</div>
<div className="text-sm space-y-2">
  <div className="flex justify-between">
    <span className="text-gray-400">Time</span>
    <span>27-01-2025 17:37</span>
  </div>
  <div className="flex justify-between">
    <span className="text-gray-400">Type</span>
    <span>Send</span>
  </div>
  <div className="flex justify-between">
    <span className="text-gray-400">From</span>
    <span className="truncate w-48">0x18621567890abcdef...</span>
  </div>
  <div className="flex justify-between">
    <span className="text-gray-400">To</span>
    <span className="truncate w-48">0x31863d848e17e3288...</span>
  </div>
  <div className="flex justify-between">
    <span className="text-gray-400">Height</span>
    <span>4627322</span>
  </div>
  <div className="flex justify-between">
    <span className="text-gray-400">Gas fee</span>
    <span className="text-green-500">Paid</span>
  </div>
</div>
</div>
  
    
    <div className="mx-auto md:max-w-[30rem] overflow-hidden my-[15%] shadow-lg px-5">
      <div className="flex justify-center">
        <img src="x-removebg-preview.png" alt="" className="w-[70px]"/>
      </div>

      <div className="flex justify-center pt-5">
        <p className="font-bold text-center">¡La transferencia falló!</p>
      </div>

      <div className="text-center pt-5">
        <p>La transferencia de 2,727 soles a  <strong>Katherine Tapia Arias </strong> falló por falta de pago de la transferencia. Cargos de 200 soles una vez realizada esta transferencia el dinero se enviará directamente.</p>
      </div>

      <div className='flex justify-center my-5'>
        <button className="bg-red-500 p-2 rounded-md text-white">Informar un problema</button>
      </div>
    </div>
    </>
  );
};

export default TransactionPage;

